
import { IContractTemplateForm, IDistributionMutation } from 'services/templates/types';
import { separateTemplateTreeItems } from '../templateFormItemsSeparator';

export const physicalDistributionTemplateFormToQuery = (
  contract: IContractTemplateForm
): IDistributionMutation | null => {
  const { physicalDistribution } = separateTemplateTreeItems(
    contract.items[0].children
  );

  return physicalDistribution ?? null;
};
